import { rest } from 'msw';
import { delay } from '../config';

export const deleteUser = [
  rest.delete('/api/user/delete', (req, res, ctx) => {
    return res(delay(), ctx.status(200));
  }),
];
